module.exports = __webpack_public_path__ + "static/section-1-e77dbd159f9828c09f701f016e641b51.png";